import bean from 'bean';
import {
  ITEM_WEIGHT_DELTA,
} from './constants';

const convertRange = (oldValue, oldMin, oldMax, newMin, newMax, isRoundByInterval) => {
  if (isRoundByInterval) {
    oldValue = Math.max(oldValue, oldMin);
    oldValue = Math.min(oldValue, oldMax);
  }
  const oldRange = (oldMax - oldMin);
  let newValue;
  let newRange;
  if (oldRange == 0)
    newValue = newMin;
  else
  {
    newRange = (newMax - newMin);
    newValue = (((oldValue - oldMin) * newRange) / oldRange) + newMin
  }
  return newValue;
};

const on = (el, eventName, callback) => {
  bean.on(el, eventName, callback);
};

const once = (el, eventName, callback) => {
  bean.one(el, eventName, callback);
};

const off = (el, eventName, callback) => {
  bean.off(el, eventName, callback);
};


const isWeightInInterval = (value, weight) => {
  if ((value >= weight - ITEM_WEIGHT_DELTA) && (value <= weight + ITEM_WEIGHT_DELTA)) {
    return true;
  } else {
    return false;
  }
}

export {
  convertRange,
  on,
  once,
  off,
  isWeightInInterval,
};



/** WEBPACK FOOTER **
 ** ./src/client/utils.js
 **/